module.exports = __webpack_public_path__ + "img/text.6c57530c.svg";